import React from 'react';
import styles from '../InpatientPortal.module.css';
import { getBatteryStatusAndColorForCard } from '../../../utils/batteryUtils';

const BatteryCard = ({ value }) => {

    const config = getBatteryStatusAndColorForCard(value);



    return (

        <div className={styles.BatterySection}>
            <p className={styles.BatteryLabel}>
                Battery:
            </p>
            <div
                style={{
                    backgroundColor: config.backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 4px',
                    borderRadius: '4px',
                    flexShrink: 0
                }}
            >
                <p
                    style={{
                        fontFamily: 'Roboto, sans-serif',
                        fontWeight: 500,
                        lineHeight: '16px',
                        fontSize: '12px',
                        color: config.textColor,
                        margin: 0,
                        fontVariationSettings: "'wdth' 100"
                    }}
                >
                    {`${config.status}${config.status === 'Unknown' ? '' : ` ${value}%`}`}
                </p>
            </div>
        </div>
    );
};

export default BatteryCard;